import create from 'zustand';
import { persist } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { User } from '~types/api/user';

// Zustand store for full API user and token

type UserStore = {
  user: User | null;
  token: string;
  setUser: (user: User) => void;
  setAccessToken: (token: string) => void;
  clearUser: () => void;
  resetUser: () => void;
};

export const useUserStore = create<UserStore>(
  persist(
    (set) => ({
      user: null,
      token: '',
      setUser: (user) => set({ user }),
      setAccessToken: (token) => set({ token }),
      clearUser: () => set({ user: null, token: '' }),
      resetUser: () => set({ user: null, token: '' }),
    }),
    {
      name: 'user-store', // storage key
      getStorage: () => AsyncStorage, // use AsyncStorage for React Native
    }
  )
);
